<template>
  <li class="TreeNode" :class="nodeClasses">
    <div class="flex justify-between">
      <tree-node-link
        :actor="actor"
        :selected="isSelected"
        :active="isActive"
        :level="level"
      />
      <actor-options v-if="isSelected && hasManagerRights" />
    </div>
    <ul v-if="actor.actors">
      <node
        v-for="child in actor.actors"
        :key="child._id"
        :actor="child"
        :level="level + 1"
        @actor-selected="setActive"
      />
      <new-actor-button
        v-if="hasManagerRights"
        v-show="isSelected"
        :root="!selectedActorID"
        :level-depth="level + 1"
        :level-width="actor.actors.length"
        :color="actor.color"
      />
    </ul>
  </li>
</template>

<script>
import TreeNodeLink from '@/components/landscape/tree/TreeNodeLink'
import {mapGetters} from 'vuex'
import NewActorButton from './NewActorButton'
import ActorOptions from '@/components/landscape/info/ActorOptions'

export default {
  name: 'Node',
  components: {ActorOptions, TreeNodeLink, NewActorButton},
  props: {
    actor: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    nodeClasses: function() {
      return {
        ['Level' + this.level]: true,
        'is-selected': this.isSelected,
        'is-active': this.isActive
      }
    },
    isSelected: function() {
      this.resetActive()
      if (this.selectedActorID === this.actor._id) {
        const tree = document.getElementById('treeContainer')
        if (tree) {
          this.$nextTick(() => {
            tree.scrollLeft = 99999
          })
        }
        this.setActive()
        return true
      }
      return false
    },
    ...mapGetters(['selectedActorID', 'hasManagerRights'])
  },
  methods: {
    setActive() {
      // One of my descendant is selected.
      // Activate myself and inform my parent
      this.isActive = true
      this.$emit('actor-selected')
    },
    resetActive() {
      this.isActive = false
    }
  }
}
</script>

<style scoped>
.TreeNode {
  margin-top: 24px;
  line-height: 0;
  &.Level0 {
    margin-top: 32px;
    margin-left: -9px;
    &:first-child {
      margin-top: 0;
    }
  }
  ul {
    padding-left: 28px;
  }
  .ActorOptions {
    margin-top: -3px;
    @apply h-4 mr-3;
  }
  /*Visibility*/
  &.Level0 ul {
    display: none;
  }
  &.is-active > ul {
    display: block;
  }
}
</style>
